const Mutations = Object.freeze({
	SET_RETAINET_VALUES:
		'inventoryFormModule/inventoryForm/inventoryFormRetainedValues/SET_RETAINET_VALUES',
});

export const Actions = Object.freeze({
	ADD: 'inventoryFormModule/inventoryForm/inventoryFormRetainedValues/ADD',
	REMOVE: 'inventoryFormModule/inventoryForm/inventoryFormRetainedValues/REMOVE',
	UPDATE: 'inventoryFormModule/inventoryForm/inventoryFormRetainedValues/UPDATE',
});

export const Getters = Object.freeze({
	RETAINED_VALUES:
		'inventoryFormModule/inventoryForm/inventoryFormRetainedValues/RETAINED_VALUES',
});

import { GeneralActions } from '../../../../actions';
export default {
	state: {
		values: localStorage.retainedValues
			? JSON.parse(localStorage.retainedValues)
			: [],
	},
	mutations: {
		[Mutations.SET_RETAINET_VALUES](state, item) {
			state.values = item;
			localStorage.retainedValues = JSON.stringify(item);
		},
	},
	actions: {
		[Actions.ADD](
			{ commit, dispatch, state },
			{ userId, inventoryFormId, formFieldId, value }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let item = {
					userId: userId,
					inventoryFormId: inventoryFormId,
					formFieldId: formFieldId,
					value: value,
				};
				let items = JSON.parse(JSON.stringify(state.values));
				items.push(item);
				commit(Mutations.SET_RETAINET_VALUES, items);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},
		[Actions.REMOVE](
			{ dispatch, commit, state },
			{ userId, inventoryFormId, formFieldId }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let items = JSON.parse(JSON.stringify(state.values));
				let item = items.find(
					(x) =>
						x.userId === userId &&
						x.inventoryFormId === inventoryFormId &&
						x.formFieldId === formFieldId
				);
				if (item) {
					let index = items.indexOf(item);
					items.splice(index, 1);
					commit(Mutations.SET_RETAINET_VALUES, items);
				}
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},
		[Actions.UPDATE](
			{ dispatch, commit, state },
			{ userId, inventoryFormId, formFieldId, value }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let newItem = {
					userId: userId,
					inventoryFormId: inventoryFormId,
					formFieldId: formFieldId,
					value: value,
				};
				let items = JSON.parse(JSON.stringify(state.values));
				let item = items.find(
					(x) =>
						x.userId === userId &&
						x.inventoryFormId === inventoryFormId &&
						x.formFieldId === formFieldId
				);
				if (item) {
					let index = items.indexOf(item);
					items.splice(index, 1, newItem);
					commit(Mutations.SET_RETAINET_VALUES, items);
				}
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},
	},
	getters: {
		[Getters.RETAINED_VALUES]: (state) => {
			if (!state.values) return [];
			return JSON.parse(JSON.stringify(state.values));
		},
	},
};
